import HomePopup from '@/features/home/components/HomePopup'
import MainAwardSection from '@/features/home/components/MainAwardSection'
import MainIntroSection from '@/features/home/components/MainIntroSection'
import MainNoticeAndNewsSection from '@/features/home/components/MainNoticeAndNewsSection'
import MainStepSwiperSection from '@/features/home/components/MainStepSwiperSection'
import MainSwiperSection from '@/features/home/components/MainSwiperSection'
import MainVideoSection from '@/features/home/components/MainVideoSection'
import PageLayout from '@/shared/components/layout/PageLayout'
import { useHomeQuery } from '@/shared/hooks/useQuery'
import MetaTag from '@/shared/seo/MetaTag'

const HomePage = () => {
  const { newsData, noticeData, popUpData, isLoading } = useHomeQuery()
  return (
    <>
      {popUpData.ImgPath && <HomePopup popUpData={popUpData} />}
      <MetaTag videoUploadDate="2024-01-05" videoUrl="https://youtu.be/_kavbpAHE9w" />
      <PageLayout>
        <MainSwiperSection />
        <MainNoticeAndNewsSection
          newsData={newsData}
          noticeData={noticeData}
          isLoading={isLoading}
        />
        <MainVideoSection />
        <MainIntroSection />
        <MainStepSwiperSection />
        <MainAwardSection />
      </PageLayout>
    </>
  )
}

export default HomePage
